import { editLocalNumber } from "helpers/requests"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import SweetAlert from "react-bootstrap-sweetalert"
import ReCAPTCHA from "react-google-recaptcha"
import {
  Button,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap"

const user = JSON.parse(localStorage.getItem("userData")) || {}

const EditLocalNumber = ({ editInfo, isOpen, toggle, refreshTable }) => {
  const [loading, setLoading] = useState(null)
  const [info, setInfo] = useState({})
  const [disableButton, setDisableButton] = useState(false)
  const [salert, setSalert] = useState({
    confirm: null,
    dynamic_description: "",
    dynamic_title: "",
    success_dlg: null,
    error_dlg: null,
    id: "",
    deleting: null,
  })
  const onCaptchaChange = value => {
    console.log("Captcha value:", value)
    setDisableButton(true)
  }

  useEffect(() => {
    setInfo(editInfo)
    console.log(editInfo)
  }, [editInfo])

  const handleChange = event => {
    setInfo({ ...info, [event.target.name]: event.target.value })
  }

  const handleLocalNumberEdit = async event => {
    setLoading(true)
    event.preventDefault()
    const data = {
      orgId: "939001",
      userGlobalId: user?.userGlobalId,
    }
    const Editted = await editLocalNumber({ ...data, ...info })
    console.log(Editted)
    setLoading(null)
    toggle()

    if (Editted?.success) {
      toggle()
      setSalert({
        confirm: false,
        success_dlg: true,
        dynamic_title: "Updated",
        dynamic_description: Editted?.message,
      })
      refreshTable()
    } else
      setSalert({
        confirm: false,
        error_dlg: true,
        dynamic_title: "Failed",
        dynamic_description: Editted?.message,
      })
  }

  return (
    <>
      {salert.success_dlg ? (
        <SweetAlert
          success
          title={salert.dynamic_title}
          onConfirm={() => setSalert({ success_dlg: false })}
        >
          {salert.dynamic_description}
        </SweetAlert>
      ) : null}

      {salert.error_dlg ? (
        <SweetAlert
          error
          title={salert.dynamic_title}
          onConfirm={() => setSalert({ error_dlg: false })}
        >
          {salert.dynamic_description}
        </SweetAlert>
      ) : null}
      <Modal
        isOpen={isOpen}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        tabIndex="-1"
        toggle={toggle}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggle}>Edit Local Number</ModalHeader>
          <Form onSubmit={handleLocalNumberEdit}>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <FormGroup className="select2-container">
                    <Label>Local Number: {info?.localNumber}</Label>
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label for="formrow-email-Input">
                      International Mobile Number
                    </Label>
                    <Input
                      type="text"
                      className="form-control"
                      id="formrow-international-number-Input"
                      value={info?.destination}
                      onChange={handleChange}
                      name="destination"
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup>
                    <Label for="formrow-nickname-Input">Nickname</Label>
                    <Input
                      type="text"
                      className="form-control"
                      name="nickname"
                      value={info?.nickname}
                      id="formrow-name-Input"
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
                <Col md={12}>
                  <FormGroup className="select2-container">
                    {/* <Label>Country</Label> */}
                    <ReCAPTCHA
                      sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                      onChange={onCaptchaChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row
                style={{
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Col md={2} style={{ flex: "1" }}></Col>
                <Col md={5} style={{ flex: "2" }}>
                  <Button
                    className="btn btn-primary btn-block waves-effect waves-light"
                    type="submit"
                    color="primary"
                    disabled={!disableButton}
                  >
                    {loading ? "Saving..." : "Save"}
                  </Button>
                </Col>
                <Col md={3} style={{ flex: "1" }}>
                  <Button color="link" onClick={toggle}>
                    Cancel
                  </Button>
                </Col>
                <Col md={2} style={{ flex: "1" }}></Col>
                <br />
                <i
                  style={{
                    color: "#000",
                    fontSize: "11px",
                    marginLeft: "10px",
                  }}
                >
                  Kindly check the captcha checkbox to enable this "Send" button
                </i>
              </Row>
            </ModalBody>
            <ModalFooter></ModalFooter>
          </Form>
        </div>
      </Modal>
    </>
  )
}

EditLocalNumber.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
}

export default EditLocalNumber
